const urlParamKeys = {
  discountCode: 'discountcode',
  paymentPeriodId: 'paymentperiodid',
  puzzlePackId: 'puzzlepackid',
  email: 'email',
} as const

export default urlParamKeys
